import type { GiftsFilters } from '@/models/gift';
import type { Pagination } from '@/models/pagination';

export const giftsQueryKey = {
  all: ['gifts'],
  filters: (filters?: GiftsFilters, pagination?: Omit<Pagination, 'total'>) =>
    filters || pagination
      ? [...giftsQueryKey.all, { filters, pagination }]
      : giftsQueryKey.all,
  detail: (id: string) => [...giftsQueryKey.all, id],
  preview: (body: unknown) => [...giftsQueryKey.all, 'preview', body],
};
